import { ref, computed } from "vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import { useStore } from "vuex";
import store from "@/store";
import useOficiosCreacion from "../useOficiosCreacion";
import Swal from "sweetalert2";

const useDialogVByCPP = () => {
  const storage = useStore();

  const {
    getFichas,
    getFichasFirmadasC,
    barraOficiosNuevos,
    barraOficiosEspera,
    barraOficiosObservacion,
    barraOficiosEnviados,
    barraOficiosFirmar,
    barraOficiosFirmar3,
    barraOficiosFirmados,
  } = useOficiosCreacion();

  const contadorOficiosVBpendientes = ref(0);
  const contadorOficiosVBpendientesAlt = ref(0);
  const barraOficiosVBpendientes = async () => {
    let arregloOficiosVBpendientes = store.state.oficialia.VoBoyCcp
    // console.log(arregloOficiosVBpendientes);

    const oficiosVBpendientesAlt = limpiarArray => limpiarArray.status == 3 && limpiarArray.statusVoBo == 1;
    const arrayLimpio = arregloOficiosVBpendientes !== undefined && arregloOficiosVBpendientes.map(oficiosVBpendientesAlt);
    //  console.log(arrayLimpio);

    let arrayLimpioAlt = Object.values(arrayLimpio);
    //  console.log(arrayLimpioAlt);
    let siHayEstatus = 0;
    let noHayEstatus = 0;
    for (let i = 0; i < arrayLimpioAlt.length; i++) {

      if (arrayLimpioAlt[i] == true) {
        siHayEstatus = siHayEstatus + 1;
      } else {
        noHayEstatus = noHayEstatus + 1;
      }
    }

    if (localStorage.getItem('cantidadOficios')) {
      const data = JSON.parse(localStorage.getItem('cantidadOficios'));
      contadorOficiosVBpendientes.value = data.vobo_pendientes;
      contadorOficiosVBpendientesAlt.value = data.vobo_pendientes;
    }
  }

  const contadorOficiosVBatendidos = ref(0);
  const contadorOficiosVBatendidosAlt = ref(0);
  const barraOficiosVBatendidos = async () => {
    let arregloOficiosVBatendidos = store.state.oficialia.VoBoyCcp
    // console.log(arregloOficiosVBpendientes);

    const oficiosVBatendidosAlt = limpiarArray => (limpiarArray.statusVoBo == 3 && limpiarArray.status == 4) || (limpiarArray.statusVoBo == 2 && limpiarArray.status == 5) || (limpiarArray.statusVoBo == 2 && limpiarArray.status == 6) || (limpiarArray.statusVoBo == 2 && limpiarArray.status == 7) || (limpiarArray.statusVoBo == 2 && limpiarArray.status == 10);
    const arrayLimpio = arregloOficiosVBatendidos !== undefined && arregloOficiosVBatendidos.map(oficiosVBatendidosAlt);
    //  console.log(arrayLimpio);

    let arrayLimpioAlt = Object.values(arrayLimpio);
    //  console.log(arrayLimpioAlt);
    let siHayEstatus = 0;
    let noHayEstatus = 0;
    for (let i = 0; i < arrayLimpioAlt.length; i++) {

      if (arrayLimpioAlt[i] == true) {
        siHayEstatus = siHayEstatus + 1;
      } else {
        noHayEstatus = noHayEstatus + 1;
      }
    }

    if (localStorage.getItem('cantidadOficios')) {
      const data = JSON.parse(localStorage.getItem('cantidadOficios'));
      contadorOficiosVBatendidos.value = data.vobo_atendidos;
      contadorOficiosVBatendidosAlt.value = data.vobo_atendidos;
    }
  }

  const contadorOficiosCCP = ref(0);
  const contadorOficiosCCPAlt = ref(0);
  const contadorOficiosOA = ref(0);
  const barraOficiosCCP = async () => {
    // let arregloOficiosCCP = store.state.oficialia.VoBoyCcp ?? 3
    // // console.log(arregloOficiosVBpendientes);
    //
    // const oficiosCCPAlt = limpiarArray => (limpiarArray.statusVoBo == 0 && limpiarArray.vobo_ccp == 1 && limpiarArray.status == 7) || limpiarArray.statusVoBo == 0 && limpiarArray.vobo_ccp == 2 && limpiarArray.status == 7;
    // const arrayLimpio = arregloOficiosCCP !== undefined && arregloOficiosCCP.map(oficiosCCPAlt);
    // //  console.log(arrayLimpio);
    //
    // let arrayLimpioAlt = Object.values(arrayLimpio);
    // //  console.log(arrayLimpioAlt);
    // let siHayEstatus = 0;
    // let noHayEstatus = 0;
    // for(let i = 0; i < arrayLimpioAlt.length; i++){
    //
    //   if( arrayLimpioAlt[i] == true){
    //    siHayEstatus = siHayEstatus + 1;
    //   }else{
    //    noHayEstatus = noHayEstatus + 1;
    //   }
    // }

    // if (localStorage.getItem('cantidadOficios') !== null) {
    const data = JSON.parse(localStorage.getItem('cantidadOficios'));
    contadorOficiosCCP.value = data?.oficios_ccp ?? 0;
    contadorOficiosCCPAlt.value = data?.oficios_ccp ?? 0;
    contadorOficiosOA.value = data?.oficios_terminados ?? 0;
    // }
  }


  const columns = ref([
    { field: "numeroOficio", header: "Número oficio" },
    { field: "fechaCreacion", header: "Fecha creación" },
    { field: "fechaRecepcion", header: "Fecha recepción" },
    { field: "asunto", header: "Asunto" },

    { field: "fechaOficio", header: "Fecha formato", hidden: true },
    { field: "ciudadFecha", header: "Fecha municipio", hidden: true },
    { field: "nota", header: "Nota", hidden: true },
    { field: "expediente", header: "Expediente", hidden: true },
    { field: "idLeyenda", header: "Leyenda", hidden: true },
    { field: "cuerpo", header: "Cuerpo", hidden: true },

    { field: "status", header: "id_estado", hidden: true },
    { field: "statusVoBo", header: "statusVoBo", hidden: true },
    { field: "idOficio", header: "idOficio", hidden: true },
    { field: "adjuntado", header: "adjuntado", hidden: true },

    {
      field: "dependenciaFirmante",
      header: "dependenciaFirmante",
      hidden: true,
    },
    {
      field: "subdependenciaFirmante",
      header: "subdependenciaFirmante",
      hidden: true,
    },
    { field: "oficinaFirmante", header: "oficinaFirmante", hidden: true },
    { field: "firmante", header: "firmante", hidden: true },
    { field: "cargoFirmante", header: "cargoFirmante", hidden: true },

    { field: "dependenciaDestinatario", header: "Dependencia que solicita" },
    {
      field: "subdependenciaDestinatario",
      header: "subdependenciaDestinatario",
      hidden: true,
    },
    { field: "oficinaDestinatario", header: "Oficina que solicita" },
    { field: "destinatario", header: "destinatario", hidden: true },
    { field: "cargoDestinatario", header: "cargoDestinatario", hidden: true },
    {
      field: "DependenciaAtencionA",
      header: "DependenciaAtencionA",
      hidden: true,
    },
    {
      field: "SubdependenciaAtencionA",
      header: "SubdependenciaAtencionA",
      hidden: true,
    },
    { field: "OficinaAtencionA", header: "OficinaAtencionA", hidden: true },
    { field: "atencionA", header: "atencionA", hidden: true },
    { field: "cargoAtencionA", header: "cargoAtencionA", hidden: true },

    { field: "stringStatus", header: "Estado", hidden: true },
    { field: "vobo_ccp", header: "Visto bueno", hidden: true },
    { field: "destinatario", header: "Destinatario" },

  ]);

  const columnsVBCPP = ref([
    { field: "id_dep", header: "IdDep", hidden: true },
    { field: "id_oficina", header: "IdOficina", hidden: true },
    { field: "titular", header: "Nombre" },
    { field: "oficina", header: "Oficina" },
    { field: "cargo", header: "Cargo" },
    { field: "dependencia", header: "Dependencia" },
    { field: "subdependencia", header: "Subdependencia" },
    { field: "vo_bo", header: "visto", hidden: true },
    { field: "accion", header: "accion", hidden: true },
  ]);

  const columnsCPP = ref([
    { field: "titular", header: "Nombre" },
    { field: "oficina", header: "Oficina" },
    { field: "cargo", header: "Cargo" },
    { field: "dependencia", header: "Dependencia" },
    { field: "subdependencia", header: "Subdependencia" },
  ]);

  const filtersTablaCCP = ref({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    titular: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    oficina: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    cargo: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    dependencia: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    subdependencia: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },

  });

  const filtersVBCPP = ref({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    nombre: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    dependencia: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    subdependencia: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    cargo: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    oficina: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
  });

  const filtersVBPendientes = ref({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    numeroOficio: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    fechaCreacion: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    asunto: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    stringStatus: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },

    fechaOficio: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    ciudadFecha: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    nota: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    expediente: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    idLeyenda: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    cuerpo: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },

    status: {
      operator: FilterOperator.OR,
      constraints: [{ value: 3, matchMode: FilterMatchMode.EQUALS }],
    },
    statusVoBo: {
      operator: FilterOperator.OR,
      constraints: [{ value: 1, matchMode: FilterMatchMode.EQUALS }],
    },
    idOficio: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    adjuntado: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },

    dependenciaFirmante: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    subdependenciaFirmante: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    oficinaFirmante: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    firmante: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    cargoFirmante: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },

    dependenciaDestinatario: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    subdependenciaDestinatario: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    oficinaDestinatario: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    destinatario: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    cargoDestinatario: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },

    DependenciaAtencionA: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    SubdependenciaAtencionA: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    OficinaAtencionA: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    atencionA: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    cargoAtencionA: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
  });

  const filtersCCP = ref({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    numeroOficio: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    fechaCreacion: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    asunto: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    stringStatus: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    fechaOficio: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    ciudadFecha: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    nota: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    expediente: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    idLeyenda: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    cuerpo: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    status: {
      operator: FilterOperator.OR,
      constraints: [{ value: 7, matchMode: FilterMatchMode.EQUALS }],
    },
    statusVoBo: {
      operator: FilterOperator.OR,
      constraints: [{ value: 0, matchMode: FilterMatchMode.EQUALS }],
    },
    vobo_ccp: {
      operator: FilterOperator.OR,
      constraints: [
        { value: 1, matchMode: FilterMatchMode.EQUALS },
        { value: 2, matchMode: FilterMatchMode.EQUALS }],
    },
    idOficio: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    adjuntado: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },

    dependenciaFirmante: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    subdependenciaFirmante: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    oficinaFirmante: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    firmante: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    cargoFirmante: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },

    dependenciaDestinatario: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    subdependenciaDestinatario: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    oficinaDestinatario: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    destinatario: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    cargoDestinatario: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },

    DependenciaAtencionA: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    SubdependenciaAtencionA: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    OficinaAtencionA: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    atencionA: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    cargoAtencionA: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
  });
  const filtersCCPAtencionOA = ref({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    numeroOficio: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },

  });

  const filtersAtendidos = ref({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    numeroOficio: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    fechaCreacion: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    asunto: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    fechaRecepcion: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    stringStatus: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },

    fechaOficio: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },

  });

  const getVoBoyCcp = async (val) => {
    const resp = await storage.dispatch(
      "oficialia/getVoBoyCcp",
      val

    );
    return resp;
  };
  const getOficiosAtencionOA = async (val) => {
    console.log('aqui')
    const resp = await storage.dispatch(
      "oficialia/getOficiosAtencionOA",
      val

    );
    return resp;
  };

  const getEstructuraFuncionarios = async (idOficio, idOficina, idDependencia) => {
    const datos = new FormData();
    datos.append("idOficio", idOficio)
    datos.append("idOficina", idOficina);
    datos.append("idDependencia", idDependencia);
    datos.append("estructura", 3);
    const { data: resp } = await store.dispatch(
      "oficialia/getEstructuraFuncionarios",
      datos
    );
    const data = resp;
    return data;
  };



  const changeVoBoCCP = async (form) => {
    const resp = await store.dispatch("oficialia/changeVoBoCCP", form);
    // await barraOficiosVBpendientes();
    // await barraOficiosVBatendidos();
    // await barraOficiosCCP();
    return resp;
  };

  const obtenerVistosBuenos = async (idOficio) => {
    const resp = await store.dispatch(
      "oficialia/obtenerVistosBuenos",
      idOficio
    );
    return resp;
  };

  const obtenerConCopia = async (idOficio) => {
    const resp = await store.dispatch("oficialia/obtenerConCopia", idOficio);
    return resp;
  };

  const enviarRevisionVoBoyCCP = async (form) => {
    const { data: info } = await store.dispatch(
      "oficialia/enviarRevisionVoBoyCCP",
      form
    );
    const { status, message } = info;
    if (status === "success") {
      await getFichas(1);
      await barraOficiosNuevos();
      await barraOficiosEspera();
      await barraOficiosObservacion();
      await barraOficiosEnviados();
      await barraOficiosFirmar();
      await barraOficiosFirmar3();
      await barraOficiosFirmados();
      window.dispatchEvent(new Event("cantidadOficiosChanged"));
      await Swal.fire("Oficio Enviado Correctamente", message, "success");
    } else {
      await getFichas(1);
      Swal.fire("Error", message, "error");
    }
  };

  const enviarOficioRecepcion = async (form) => {
    const { data: info } = await store.dispatch(
      "oficialia/enviarOficioRecepcion",
      form
    );
    console.log(info)
    if (info == undefined) {
      Swal.fire("Error", "Error al enviar el oficio", "error");
      return;
    }
    const { status, message } = info;
    if (status === "success") {
      await getFichas(5);
      await getFichasFirmadasC();
      await barraOficiosNuevos();
      await barraOficiosEspera();
      await barraOficiosObservacion();
      await barraOficiosEnviados();
      await barraOficiosFirmar();
      await barraOficiosFirmar3();
      await barraOficiosFirmados();
      window.dispatchEvent(new Event("cantidadOficiosChanged"));
      Swal.fire("Oficio Enviado Correctamente", message, "success");
    } else {
      await getFichas(5);
      Swal.fire("Error", "Error al enviar el oficio", "error");
    }
  };

  const updateVoBo = async (form) => {
    const { data: info } = await store.dispatch("oficialia/updateVoBo", form);
    const { status, message } = info;
    if (status === "success") {
      await getVoBoyCcp(1);
      await barraOficiosVBpendientes();
      await barraOficiosVBatendidos();
      window.dispatchEvent(new Event("cantidadOficiosChanged"));
      Swal.fire("Proceso Completado", message, "success");
    } else {
      await getVoBoyCcp(1);
      await barraOficiosVBpendientes();
      await barraOficiosVBatendidos();
      Swal.fire("Error", message, "error");
    }
  };

  const getDependenciasVBCCP = async (form) => {
    const resp = await store.dispatch("oficialia/getDependenciasVBCCP", form);
    return resp
  }

  const getOficinasVBCCP = async (dependencia) => {
    return await store.dispatch("oficialia/getOficinasVBCCP", dependencia);
  }


  return {
    getEstructuraFuncionarios,
    getVoBoyCcp,
    getOficiosAtencionOA,
    VoBoyCcp: computed(() => storage.getters["oficialia/getVoBoByUsuario"]),
    oficiosAtencionOA: computed(() => storage.getters["oficialia/getOficiosAtencionOA"]),
    funcionariosState: computed(
      () => store.getters["oficialia/getFuncionarios"]
    ),
    getDependenciasVBCCP,
    tablaVBCCP: computed(() => storage.getters["oficialia/getDependenciasVBCCP"]),

    getOficinasVBCCP,
    // tablaOFVBCCP: computed(() => storage.getters["oficialia/getOficinasVBCCP"]),

    columns,
    columnsVBCPP,
    filtersVBCPP,
    filtersVBPendientes,
    filtersCCP,
    filtersCCPAtencionOA,
    filtersAtendidos,
    changeVoBoCCP,
    obtenerVistosBuenos,
    obtenerConCopia,
    enviarRevisionVoBoyCCP,
    enviarOficioRecepcion,
    updateVoBo,

    contadorOficiosVBpendientes,
    contadorOficiosVBpendientesAlt,
    barraOficiosVBpendientes,

    contadorOficiosVBatendidos,
    contadorOficiosVBatendidosAlt,
    barraOficiosVBatendidos,

    contadorOficiosCCP,
    contadorOficiosOA,
    contadorOficiosCCPAlt,
    barraOficiosCCP,

    columnsCPP,
    filtersTablaCCP,
  };
};
export default useDialogVByCPP;
